var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'tip': true, 'tip--compact': _vm.compact }},[(_vm.isActive)?_c('div',{staticClass:"tip__wrapper"},[_c('div',{staticClass:"tip__item"},[_vm._v("?")]),_c('div',{staticClass:"tip__body"},[_vm._v(_vm._s(_vm.getTipName(_vm.tipId)))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }